import { map } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import SearchField from '../Shared/SearchField';
import { setSearch } from '../../data/searchField/actions';

class VRAPendingSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealerNumber: '',
      vin: '',
      vra: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const { setSearchFields } = this.props;
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({ [name]: value });
    setSearchFields({ [name]: value });
  }

  render() {
    const {
      onSubmit,
      searchFields,
      searchOptions,
      multipleSearches,
    } = this.props;
    // eslint-disable-next-line prefer-destructuring
    const { state } = this;

    return (
      <div>
        <Form onSubmit={onSubmit}>
          <Form.Group widths='two'>
            {map(searchOptions, searchOption => (
              <SearchField
                handleInputChange={this.handleInputChange}
                searchOption={searchOption}
                searchFields={searchFields}
                value={state[searchOption]}
                multipleSearches={multipleSearches}
                key={searchOption}
              />
            ))}
            <Form.Field>
              <Form.Button color='green' inverted>
                Search
              </Form.Button>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setSearchFields: fields => {
    dispatch(setSearch(fields));
  },
});

VRAPendingSearch.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  searchFields: PropTypes.object,
  searchOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSearchFields: PropTypes.func.isRequired,
  multipleSearches: PropTypes.bool,
};

export default compose(connect(null, mapDispatchToProps))(VRAPendingSearch);
